<template>
  <div>
    <div>
      <span>Type:</span>
      <el-select v-model="formData.State"
                 clearable
                 filterable
                 size="mini"
                 @change="changeSelect"
                 placeholder="please select">
        <el-option
            v-for="item in state_list"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
<!--      <el-button size="mini" type="info" round style="margin-left: 10px" @click="changeSelect">submit</el-button>-->
    </div>
    <div style="width: 400px;height: 400px;" :id="statePicId" />
  </div>
</template>

<script>
import * as echarts from "echarts/core";

export default {
  name: "StateCard",
  data(){
    return{
      statePicId: '',
      formData: {
        datasetID: '',
        Array:  '',
        State: 'Angiogenesis',
      },
      state_list: ["Angiogenesis","Apoptosis","Cell cycle","Differentiation","DNA damage","DNA repair",
        "EMT","Hypoxia","Inflammation","Invasion","Metastasis","Proliferation","Quiescence","Stemness"],
      state_data: {
        Angiogenesis: [],
        Apoptosis: [],
        CellCycle: [],
        Differentiation: [],
        DNADamage: [],
        DNARepair: [],
        EMT: [],
        Hypoxia: [],
        Inflammation: [],
        Invasion: [],
        Metastasis: [],
        Proliferation: [],
        Quiescence: [],
        Stemness: [],
      },
    }
  },
  props:{
    cardID: String,
  },
  mounted() {
    this.statePicId = 'state_pic' + this.cardID
    this.formData.datasetID = this.$attrs.data.datasetID
    this.formData.Array = this.$attrs.data.array
    this.$nextTick(function () {
      this.initEcharts()
      this.getStateData()
    })
  },
  methods:{
    initEcharts(){
      let _this = this
      let _div = document.getElementById(this.statePicId);
      let myChart = this.$echarts.getInstanceByDom(_div);
      if (myChart == null) {
        myChart = echarts.init(_div);
      }
      // const chartDom = document.getElementById('dataset_state_main');
      // const myChart = echarts.init(chartDom);
      let option;
      const schema = [
        { name: 'no', index: 0, text: 'no' },
        { name: 'x', index: 1, text: 'x' },
        { name: 'y', index: 2, text: 'y' },
        { name: 'spot', index: 3, text: 'spot' },
        { name: 'score', index: 4, text: 'score' },
      ];
      const itemStyle = {
        emphasis: {
          focus : 'self'
        }
      };
      option = {
        color: ['#FF0000', '#FF8000', '#FFFF00', '#80FF00', '#00FF00', '#00FF80', '#00FFFF',
          '#0080FF', '#0000FF', '#7F00FF', '#FF00FF', '#FF007F', '#808080', '#FF7F7F'],
        toolbox: {
          show: true,
          top: 20,
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage: {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        legend: {
          x: 'center',
          y: 'top',
          textStyle: {
            fontWeight: 'bold',
            color: 'red',
            fontSize: 10
          }
        },
        grid: {
          right: 100,
        },
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          formatter: function (param) {
            // console.log(param)
            var value = param.value;
            // prettier-ignore
            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                + _this.formData.State
                + '</div>'
                // + schema[0].text + '：' + value[2] + '<br>'
                + schema[1].text + ': ' + value[0] + '<br>'
                + schema[2].text + ': ' + value[1] + '<br>'
                + schema[3].text + ': ' + value[3] + '<br>'
                + schema[4].text + ': ' + value[4] + '<br>';
          }
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        visualMap: [
          {
            left: 'right',
            bottom: '30%',
            dimension: 4,
            type: 'continuous',
            calculable:true,                        //是否显示拖拽用的手柄（手柄能拖拽调整选中范围）
            realtime:true,                          //拖拽时，是否实时更新
            precision:3,                            //数据展示的小数精度，默认为0，无小数点
            min: 0,
            max: 1,
            itemHeight: 120,
            align:"auto",
            text: ['score'],
            textGap: 30,
            inRange: {
              // colorLightness: [1, 0.4],
              color: ['#d9d9d9','blue']
            },
            outOfRange: {
              color: ['rgba(255,255,255,0.4)']
            },
            controller: {
              inRange: {
                color: ['#d9d9d9','blue']
                // color: ['#c23531']
                // color: ['#FFFFFF']
              },
              outOfRange: {
                color: ['#999']
              }
            }
          }
        ],
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        series: [
          {
            type: 'scatter',
            itemStyle: itemStyle,
            // large: true,                //是否开启大规模散点图的优化，在数据图形特别多的时候（>=5k）可以开启。开启后配合 largeThreshold 在数据量大于指定阈值的时候对绘制进行优化。缺点：优化后不能自定义设置单个数据项的样式。
            // largeThreshold:5000,        //开启绘制优化的阈值。
            data: _this.state_data.Angiogenesis,
            symbolSize: 3,
          },
        ]
      };
      option && myChart.setOption(option);
    },
    getStateData(){
      let _this = this
      // console.log(_this.formData.DatasetID+" "+_this.formData.Type+" "+_this.formData.State)
      _this.formData.State = 'Angiogenesis'
      _this.state_data.Angiogenesis = []
      _this.state_data.Apoptosis= []
      _this.state_data.CellCycle = []
      _this.state_data.Differentiation = []
      _this.state_data.DNADamage = []
      _this.state_data.DNARepair = []
      _this.state_data.EMT = []
      _this.state_data.Hypoxia = []
      _this.state_data.Inflammation = []
      _this.state_data.Invasion = []
      _this.state_data.Metastasis = []
      _this.state_data.Proliferation = []
      _this.state_data.Quiescence = []
      _this.state_data.Stemness = []
      _this.changeSelect()
    },
    changeSelect() {
      let _this = this
      console.log(_this.formData.datasetID+" "+_this.formData.Array+" "+_this.formData.State)
      // console.log(resolve,reject)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/state/'+ _this.formData.datasetID
          +'/'+ _this.formData.Array +'/'+ _this.formData.State )
          .then(function (response){
            // console.log(response.data)
            let name = Object.keys(response.data).pop()
            _this.state_data[name] = response.data[name]
            const myChart = echarts.getInstanceByDom(document.getElementById(_this.statePicId));
            let option;
            const itemStyle = {
              emphasis: {
                focus : 'self'
              }
            };
            myChart.setOption({
              series: [
                {
                  type: 'scatter',
                  itemStyle: itemStyle,
                  // large: true,                //是否开启大规模散点图的优化，在数据图形特别多的时候（>=5k）可以开启。开启后配合 largeThreshold 在数据量大于指定阈值的时候对绘制进行优化。缺点：优化后不能自定义设置单个数据项的样式。
                  // largeThreshold:5000,        //开启绘制优化的阈值。
                  data: _this.state_data[name],
                  symbolSize: 3,
                },
              ]
            })
            // chartDom.setAttribute('_echarts_instance_', '')
            option && myChart.setOption(option,true);
          })
    },
  }
}
</script>

<style scoped>

</style>
